module.exports = __webpack_public_path__ + "media/app/assets/classes/warlock-041b21aa3a749f09f89b7f5c47d00ccd.jpg";